import { Injectable } from '@angular/core';
import { LiteEvent } from './index';

@Injectable()
export class PanelDataExchangeService {
    private _showRouteInfoPanel = new LiteEvent<boolean>();
    private _showBuiltRouteInfoPanel = new LiteEvent<boolean>();
    private _showInfoPanel = new LiteEvent<boolean>();
    private _showLegendPanel = new LiteEvent<boolean>();
    private _showBuildRoutePanel = new LiteEvent<boolean>();
    private _showPOIInfoPanel = new LiteEvent<boolean>();
    
    get showRouteInfoPanelHandler() { return this._showRouteInfoPanel.expose(); }
    get showBuiltRouteInfoPanelHandler() { return this._showBuiltRouteInfoPanel.expose(); }
    get showInfoPanelHandler() { return this._showInfoPanel.expose(); }
    get showLegendPanelHandler() { return this._showLegendPanel.expose(); }
    get showBuildRoutePanelHandler() { return this._showBuildRoutePanel.expose(); }
    get showPOIInfoPanelHandler() { return this._showPOIInfoPanel.expose(); }
    
    showRouteInfoPanel(isShown: boolean) {
        if (this._showRouteInfoPanel)
            this._showRouteInfoPanel.trigger(isShown);
    }
    showBuiltRouteInfoPanel(isShown: boolean) {
        if (this._showBuiltRouteInfoPanel)
            this._showBuiltRouteInfoPanel.trigger(isShown);
    }
    showInfoPanel(isShown: boolean) {
        if (this._showInfoPanel)
            this._showInfoPanel.trigger(isShown);
    }
    showLegendPanel(isShown: boolean) {
        if (this._showLegendPanel)
            this._showLegendPanel.trigger(isShown);
    }
    showBuildRoutePanel(isShown: boolean) {
        if (this._showBuildRoutePanel)
            this._showBuildRoutePanel.trigger(isShown);
    }
    showPOIInfoPanel(isShown: boolean) {
        if (this._showPOIInfoPanel)
            this._showPOIInfoPanel.trigger(isShown);
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/panel-data-exchange.service.ts